/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionSubtypeSchema = z.enum(['name', 'email', 'phone', 'multiple'])

export type QuestionSubtypeSchema = z.infer<typeof questionSubtypeSchema>
